class OperationType {
    id: number;
    name: string;

    constructor(operationType) {
        this.id = operationType.id;
        this.name = operationType.name;
    }
}

export class MaintenanceFile {
    contentType: string;
    extension: string;
    id: number;
    name: string;
    url: string;

    constructor(maintenanceFile) {
        this.contentType = maintenanceFile.contentType;
        this.extension = maintenanceFile.extension;
        this.id = maintenanceFile.id;
        this.name = maintenanceFile.name;
        this.url = maintenanceFile.url;
    }
}

export class MaintenancePlan {
    description: string;
    file: MaintenanceFile;
    id: number;
    operation: OperationType;
    value: string;

    constructor(toolMaintenancePlan) {
        this.description = toolMaintenancePlan.description;
        this.file = new MaintenanceFile(toolMaintenancePlan.file);
        this.id = toolMaintenancePlan.id;
        this.operation = new OperationType(toolMaintenancePlan.operation);
        this.value = toolMaintenancePlan.value;
    }

    get type() {
        return "tool-intervention";
    }
}
